import { render } from "./tourism.vue?vue&type=template&id=44dd6ade&scoped=true"
import script from "./tourism.vue?vue&type=script&lang=js"
export * from "./tourism.vue?vue&type=script&lang=js"

import "./tourism.vue?vue&type=style&index=0&id=44dd6ade&lang=scss&scoped=true"
import "./tourism.vue?vue&type=style&index=1&id=44dd6ade&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dd6ade"]])

export default __exports__